import Container from "./components/Container";
import MintingCows from "./components/MintingCows";
import StakingCows from "./components/StakingCows";
import { useQuery } from "@apollo/client";
import { parseGraphObject2, QUERYCOWS } from "./utils/queryCows";
import WoodButton from "./components/WoodButton";
import Menu from "./components/Menu";

const Cows = ({ wallet, chain, wool, milk, reload }) => {
    const { data, loading, refetch, error } = useQuery(QUERYCOWS, {
        variables: {
            wallet: wallet || "",
        },
        pollInterval: 2500,
    });

    if (error) {
        console.log("data NOK %s", error);
    }

    let staked = [];
    let tokens = [];
    if (data) {
        tokens = [...data.tokens.map(x => parseGraphObject2(x))].sort((e1, e2) => {
            return parseInt(e1.id, 16) - parseInt(e2.id, 16);
        });
        staked = [...data.stakes.map(x => parseGraphObject2(x))].sort((e1, e2) => {
            return parseInt(e1.id, 16) - parseInt(e2.id, 16);
        });

        console.log(data);
        console.log(QUERYCOWS);
        console.log(wallet);
    }

    return (
        <>
            <Menu />
            <div style={{ paddingTop: "64px" }}>
                <div className="w-full flex flex-col md:justify-center items-center p-5">
                    <div className="title text-center justify-self-start mb-5">Avax Wolf Game</div>

                    <div className="mb-5 font-console text-red text-sm" style={{ maxWidth: "600px" }}>
                        <Container transparent={false}>
                            <div className="flex flex-col jsutify-center items-center">
                                avaCOWS are here ! get your avaCOW and earn $avaMILK on a farm in the metaverse. Nothing but blockchain. No roadmap. Fully in the Public Domain.
                                <br />
                                <br />
                                10000 cows, mintable only with $avaWOOL
                                <br />
                                <br />
                                Each cow gives you 10000 $avaMILK per day
                                <br />
                                <br />
                                <div className="flex flex-col md:flex-row justify-center items-center gap-5 mb-2">
                                    <img src="./images/public-domain.png" style={{ maxHeight: "50px" }} alt="public domain" />
                                </div>
                                {/*<a className="underline" href="./tos" target="_blank" >terms of service</a>*/}
                            </div>
                        </Container>
                    </div>

                    <div className="flex flex-col md:flex-row justify-center items-center gap-10 w-full" style={{ maxWidth: "1500px" }}>
                        <div className="h-full w-full md:w-1/2 flex justify-between flex flex-col gap-5">
                            <MintingCows
                                wallet={wallet}
                                chain={chain}
                                stats={data?.stat}
                                reload={() => {
                                    refetch();
                                    reload();
                                }}
                                woolBalance={wool}
                            />
                        </div>
                        <div className="h-full w-full md:w-1/2 flex justify-center">
                            <StakingCows
                                wallet={wallet}
                                chain={chain}
                                wool={wool}
                                milk={milk}
                                tokens={tokens}
                                stakes={staked}
                                stats={data?.stat}
                                reload={() => {
                                    refetch();
                                    reload();
                                }}
                                fetching={loading}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

// <img className="absolute h-full w-full object-cover" src="./images/background.png" alt="" style={{zIndex:-1000}}/>

export default Cows;
